import * as React from 'react';

import PropTypes from 'prop-types';

import requestCountryCode from 'bundles/phoenix/template/models/requestCountryCode';

export default function provideRequestCountryCode<Props extends {}>(
  Component: React.ComponentType<Props>
): React.ComponentClass<Props> {
  const componentName = Component.displayName || Component.name;

  class RequestCountryCodeContextProvider extends React.Component<Props> {
    static displayName = componentName + 'RequestCountryCodeContextProvider';

    static childContextTypes = {
      requestCountryCode: PropTypes.string,
    };

    getChildContext() {
      return {
        requestCountryCode,
      };
    }

    render() {
      return React.createElement(Component, this.props);
    }
  }

  return RequestCountryCodeContextProvider;
}
